export default "__VITE_ASSET__LVg2A0nD__"